var initSwipers = function initSwipers() {
  new Swiper('.new-arrivals-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    scrollbar: {
      el: '.new-arrivals-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.new-arrivals-button-next',
      prevEl: '.new-arrivals-button-prev'
    },
    breakpoints: {
      1024: {
        slidesPerView: 4
      }
    }
  });
  new Swiper('.quick-view-slider', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.quick-view-slider-button-next',
      prevEl: '.quick-view-slider-button-prev'
    }
  });
  new Swiper('.ribbons-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    scrollbar: {
      el: '.ribbons-scrollbar',
      draggable: true
    },
    breakpoints: {
      768: {
        noSwiping: true,
        noSwipingClass: 'swiper-no-swiping',
        allowSlidePrev: false,
        allowSlideNext: false,
        centeredSlides: false
      }
    }
  });

  // new Swiper('.media-slider', {
  //   slidesPerView: 1,
  //   scrollbar: {
  //     el: '.media-slider-scrollbar',
  //     draggable: true
  //   }
  // })

  new Swiper('.list-collection-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: true,
    scrollbar: {
      el: '.list-collection-scrollbar',
      draggable: true
    },
    breakpoints: {
      425: {
        slidesPerView: 2,
        centeredSlides: false
      },
      768: {
        slidesPerView: 3,
        centeredSlides: false
      },
      1024: {
        slidesPerView: 5,
        noSwiping: true,
        noSwipingClass: 'swiper-no-swiping',
        allowSlidePrev: false,
        allowSlideNext: false,
        centeredSlides: false
      }
    }
  });
  new Swiper('.manual-review-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: true,
    scrollbar: {
      el: '.manual-review-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.manual-review-button-next',
      prevEl: '.manual-review-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        centeredSlides: false
      }
    }
  });
  new Swiper('.content-block__slider', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: true,
    scrollbar: {
      el: '.content-block-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.content-block-button-next',
      prevEl: '.content-block-button-prev'
    }
  });
  new Swiper('.image-content__swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: true,
    scrollbar: {
      el: '.image-content-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.image-content-button-next',
      prevEl: '.image-content-button-prev'
    }
  });
  new Swiper('.manual-instagram__swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: false,
    scrollbar: {
      el: '.manual-instagram__scrollbar',
      draggable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        centeredSlides: false
      },
      1024: {
        slidesPerView: 4
      }
    }
  });
  new Swiper('.complete-look-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    scrollbar: {
      el: '.complete-look-scrollbar',
      draggable: true
    }
  });
  new Swiper('.explore-blogs__swiper', {
    slidesPerView: 'auto',
    spaceBetween: 15,
    centeredSlides: true,
    scrollbar: {
      el: '.explore-blogs__scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.explore-blogs__button-next',
      prevEl: '.explore-blogs__button-prev'
    },
    breakpoints: {
      768: {
        centeredSlides: false
      },
      1024: {
        centeredSlides: false
      }
    }
  });
  new Swiper('.product-recommendations-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    scrollbar: {
      el: '.product-recommendations-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.product-recommendations-button-next',
      prevEl: '.product-recommendations-button-prev'
    },
    breakpoints: {
      1024: {
        slidesPerView: 4
      }
    }
  });
  new Swiper('.simple-card-slider-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    scrollbar: {
      el: '.simple-card-slider-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.simple-card-slider-button-next',
      prevEl: '.simple-card-slider-button-prev'
    },
    breakpoints: {
      1024: {
        slidesPerView: 4
      }
    }
  });
  if (document.querySelector('.splash-page__swiper-text')) {
    var splashHeading = new Swiper('.splash-page__swiper-text', {
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      autoHeight: true
    });
    var splashSlide = new Swiper('.splash-page__swiper', {
      slidesPerView: 1,
      effect: 'fade',
      autoplay: {
        delay: 8000
      },
      freeMode: true,
      loop: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.splash-page__swiper-button-next',
        prevEl: '.splash-page__swiper-button-prev'
      },
      pagination: {
        el: '.splash-page__swiper-pagination'
      },
      thumbs: {
        swiper: splashHeading
      }
    });
    splashSlide.update();
  }
  new Swiper('.hero-carousel-swiper', {
    slidesPerView: 1,
    autoplay: {
      delay: 5000
    },
    effect: 'fade',
    navigation: {
      nextEl: '.hero-carousel-swiper-button-next',
      prevEl: '.hero-carousel-swiper-button-prev'
    }
  });
  new Swiper('.hero-video-carousel__swiper', {
    slidesPerView: 1,
    autoplay: {
      delay: 7000
    },
    effect: 'fade',
    pagination: {
      el: '.hero-video-carousel__swiper .swiper-pagination',
      // Target the pagination container
      clickable: true // Make dots clickable
    },
    navigation: {
      nextEl: '.mainbanner-button-next',
      prevEl: '.mainbanner-button-prev'
    }
  });
};
export { initSwipers };